import {
  UserDetails,
  ProfileData as UserEntityData,
} from "../../common/common.model";
import { IClauseMeta } from "./AntdTable.types";
import {
  getClauseMetadata,
  getClausesDataFromListApi,
  getClausesOverviewDataFromListApi,
  getLocalDateTimeFromTimestamp,
} from "./AntdTable.utils";

export class ClauseCheckRow {
  available_clauses: number;
  id: string;
  name: string;
  display_name: string;
  status: string;
  clause_check_overview: {
    vendor_name?: {
      value: string;
    };
    contract_type?: {
      value: string;
    };
    title?: {
      value: string;
    };
    start_date?: {
      value: string;
    };
    end_date?: {
      value: string;
    };
    document_id?: {
      value: string;
    };
    simba_id?: {
      value: string;
    };
    contract_id?: {
      value: string;
    };
    maximum_total_cost?: {
      value: string;
    };
    service_type?: {
      value: string;
    };
  };
  clause_meta: IClauseMeta[];
  clause_check_summary: {
    [key: string]: any;
  };
  driveFileId: string;
  constructor(obj: any) {
    this.available_clauses = obj?.available_clauses;
    this.id = obj?.id;
    this.name = obj?.name;
    this.display_name = obj?.display_name;
    this.status = obj?.status;
    this.driveFileId = obj?.drive_details?.file_id;
    this.clause_check_overview = getClausesOverviewDataFromListApi(
      obj?.clause_meta
    );
    this.clause_meta = getClauseMetadata(obj?.clause_meta || []);
    this.clause_check_summary = getClausesDataFromListApi(
      obj?.clause_check_details
    );
  }
}

export class ClauseCheckTable {
  count: number;
  results: ClauseCheckRow[];
  previous: any;
  next: any;
  clausesForVertical: [];

  constructor(obj: any) {
    this.count = obj?.count;
    this.results = obj?.results?.map((res: any) => new ClauseCheckRow(res));
    this.previous = obj?.previous;
    this.next = obj?.next;
    this.clausesForVertical = [];
  }
}

export class ClauseCheckAdvancedRow {
  available_clauses: number;
  total_clauses: number;
  id: string;
  name: string;
  display_name: string;
  status: string;
  gcs_file_path: string;
  message: string;
  created_at: string;
  updated_at: string;
  clause_check_overview: {
    vendor_name?: {
      value: string;
    };
    contract_type?: {
      value: string;
    };
    title?: {
      value: string;
    };
    start_date?: {
      value: string;
    };
    end_date?: {
      value: string;
    };
    document_id?: {
      value: string;
    };
    simba_id?: {
      value: string;
    };
    contract_id?: {
      value: string;
    };
    maximum_total_cost?: {
      value: string;
    };
    service_type?: {
      value: string;
    };
  };
  clause_meta: IClauseMeta[];
  clause_check_summary: {
    [key: string]: any;
  };
  clause_check_details: any[];
  driveFileId: string;

  constructor(obj: any) {
    this.available_clauses = obj?.available_clauses || 0;
    this.total_clauses = obj?.total_clauses || 0;
    this.id = obj?.id;
    this.name = obj?.name;
    this.display_name = obj?.display_name;
    this.status = obj?.status;
    this.gcs_file_path = obj?.gcs_file_path;
    this.message = obj?.message;
    this.created_at = obj?.created_at;
    this.updated_at = obj?.updated_at;
    this.driveFileId = obj?.drive_details?.file_id;
    this.clause_check_details = obj?.clause_check_details || [];
    
    this.clause_check_overview = getClausesOverviewDataFromListApi(
      obj?.clause_meta
    );
    this.clause_meta = getClauseMetadata(obj?.clause_meta || []);
    this.clause_check_summary = getClausesDataFromListApi(
      obj?.clause_check_details
    );
  }
}

export class ClauseCheckAdvancedTable {
  count: number;
  results: ClauseCheckAdvancedRow[];
  previous: any;
  next: any;
  clausesForVertical: [];

  constructor(obj: any) {
    this.count = obj?.count || 0;
    this.results = obj?.results?.map((res: any) => new ClauseCheckAdvancedRow(res)) || [];
    this.previous = obj?.previous;
    this.next = obj?.next;
    this.clausesForVertical = [];
  }
}

export class ClauseCheckAgenticRow {
  id: string;
  file_id: string;
  file_name: string;
  folder_path: string;
  extraction_timestamp: string;
  vendor: string;
  contract_name: string;
  contract_id: string;
  source_type: string;
  rag_corpus_id: string;
  clause_items: {
    clause_name: string;
    clause_data: string;
    is_present: boolean;
  }[];
  sow_start_date: string;
  sow_end_date: string;
  total_contract_value: number;
  services_included: string[];
  available_clauses: number;
  total_clauses: number;
  name: string;
  display_name: string;
  status: string;
  gcs_file_path: string;
  message: string;
  created_at: string;
  updated_at: string;
  clause_check_overview: {
    vendor_name?: {
      value: string;
    };
    contract_type?: {
      value: string;
    };
    title?: {
      value: string;
    };
    start_date?: {
      value: string;
    };
    end_date?: {
      value: string;
    };
    document_id?: {
      value: string;
    };
    simba_id?: {
      value: string;
    };
    contract_id?: {
      value: string;
    };
    maximum_total_cost?: {
      value: string;
    };
    service_type?: {
      value: string;
    };
  };
  clause_meta: IClauseMeta[];
  clause_check_summary: {
    [key: string]: any;
  };
  clause_check_details: any[];
  driveFileId: string;

  constructor(obj: any) {
    this.id = obj?.id;
    this.file_id = obj?.file_id;
    this.file_name = obj?.file_name;
    this.folder_path = obj?.folder_path;
    this.extraction_timestamp = obj?.extraction_timestamp;
    this.vendor = obj?.vendor;
    this.contract_name = obj?.contract_name;
    this.contract_id = obj?.contract_id;
    this.source_type = obj?.source_type;
    this.rag_corpus_id = obj?.rag_corpus_id;
    this.clause_items = obj?.clause_items || [];
    this.sow_start_date = obj?.sow_start_date;
    this.sow_end_date = obj?.sow_end_date;
    this.total_contract_value = obj?.total_contract_value;
    this.services_included = obj?.services_included || [];

    this.available_clauses = this.clause_items?.filter(item => item.is_present).length || 0;
    this.total_clauses = this.clause_items?.length || 0;
    this.name = this.file_name;
    this.display_name = this.contract_name || this.file_name;
    this.status = "completed"; 
    this.gcs_file_path = this.folder_path;
    this.message = "";
    this.created_at = this.extraction_timestamp;
    this.updated_at = this.extraction_timestamp;
    this.driveFileId = this.id; 

    // Transform clause_items to expected format for compatibility
    const clauseMetaData = this.clause_items?.map(item => ({
      metadata_name: "title",
      display_name: "Contract Title",
      value: this.contract_name || this.file_name,
    })) || [];

    this.clause_check_overview = {
      vendor_name: {
        value: this.vendor
      },
      contract_type: {
        value: "Service Agreement" 
      },
      title: {
        value: this.contract_name || this.file_name
      },
      start_date: {
        value: this.sow_start_date
      },
      end_date: {
        value: this.sow_end_date
      },
      document_id: {
        value: this.id
      },
      contract_id: {
        value: this.contract_id
      },
      maximum_total_cost: {
        value: this.total_contract_value?.toString()
      },
      service_type: {
        value: this.services_included?.join(", ")
      },
    };

    this.clause_meta = clauseMetaData;
    
    // Transform clause_items to clause_check_summary format
    const clauseCheckSummary: { [key: string]: any } = {};
    this.clause_items?.forEach(item => {
      clauseCheckSummary[item.clause_name] = {
        is_present: item.is_present,
        contract_content: item.clause_data,
        category: item.clause_name
      };
    });
    this.clause_check_summary = clauseCheckSummary;
    this.clause_check_details = this.clause_items || [];
  }
}

export class ClauseCheckAgenticTable {
  count: number;
  results: ClauseCheckAgenticRow[];
  previous: any;
  next: any;
  clausesForVertical: any[];
  newlyAddedClausesByVertical: { [verticalId: string]: string[] };

  constructor(obj: any) {
    this.count = obj?.data?.total_count || 0;
    this.results = obj?.data?.files?.map((file: any) => new ClauseCheckAgenticRow(file)) || [];
    this.previous = obj?.data?.has_previous ? "previous" : null;
    this.next = obj?.data?.has_next ? "next" : null;
    
    // Use active_clauses directly from the response
    const activeClauses = obj?.data?.active_clauses || [];
    this.newlyAddedClausesByVertical = obj?.data?.newly_added_clauses_by_vertical || {};
    
    this.clausesForVertical = activeClauses.map((clauseName: string) => ({
      id: clauseName.replace(/\s+/g, '_').toLowerCase(),
      name: clauseName,
      display_name: clauseName,
      is_enabled: true
    }));
  }
}

export class ClauseCheckAdvancedBatchRow {
  id: string;
  vertical: {
    id: string;
    name: string;
    display_name: string;
    drive_link: string | null;
    is_enabled: boolean;
    enabled_count: {
      clause_check: number;
      redlining: number;
    };
    service_account_email: string | null;
  };
  created_by: UserDetails;
  status: string;
  created_at: string;
  updated_at: string;
  documents_count: number;

  constructor(obj: any) {
    this.id = obj?.id;
    this.vertical = obj?.vertical;
    this.created_by = new UserDetails(obj?.created_by);
    this.status = obj?.status;
    this.created_at = obj?.created_at;
    this.updated_at = obj?.updated_at;
    this.documents_count = obj?.documents_count;
  }
}

export class ClauseCheckAdvancedBatchTable {
  count: number;
  results: ClauseCheckAdvancedBatchRow[];
  previous: any;
  next: any;
  clausesForVertical: [];

  constructor(obj: any) {
    this.count = obj?.data?.pagination?.total_count || 0;
    this.results =
      obj?.data?.batch_jobs?.map(
        (job: any) => new ClauseCheckAdvancedBatchRow(job)
      ) || [];
    this.previous = obj?.data?.pagination?.has_previous ? "previous" : null;
    this.next = obj?.data?.pagination?.has_next ? "next" : null;
    this.clausesForVertical = [];
  }
}

export class UserManagementTable {
  count: number;
  results: UserEntityData[];
  previous: any;
  next: any;

  constructor(obj: any) {
    this.count = obj?.count;
    this.results = obj?.results?.map((res: any) => new UserEntityData(res));
    this.previous = obj?.previous;
    this.next = obj?.next;
  }
}

export class ExpiringContractData {
  id: string;
  start_date: string;
  end_date: string;
  file_name: string;
  vendor: string;
  status: string;
  gdrive_file_id: string;
  gdrive_path: string;
  remaining_days: number;
  constructor(obj: any) {
    this.id = obj?.id;
    this.file_name = obj?.file_name;
    this.vendor = obj?.vendor;
    this.status = obj?.status;
    this.gdrive_file_id = obj?.gdrive_file_id;
    this.gdrive_path = obj?.gdrive_path;
    this.start_date = obj?.start_date;
    this.end_date = obj?.end_date;
    this.remaining_days = obj?.remaining_days;
  }
}

// V2 Model for Hierarchical Contract Data (Agentic Dashboard)
export class HierarchicalContractData {
  id: string;
  contract_id?: string;
  simba_id?: string;
  project_title?: string;
  file_name: string;
  vendor: string;
  status: string;
  gdrive_file_id: string;
  gdrive_path: string;
  folder_path?: string;
  start_date: string;
  end_date: string;
  updated_end_date?: string;
  remaining_days: number;
  contract_type: string;
  sow_number?: string;
  order_form_number?: string;
  children?: any[];
  expanded?: boolean;

  constructor(obj: any) {
    this.id = obj?.id;
    this.contract_id = obj?.contract_id;
    this.simba_id = obj?.simba_id;
    this.project_title = obj?.project_title;
    this.file_name = obj?.file_name;
    this.vendor = obj?.vendor;
    this.status = obj?.status;
    this.gdrive_file_id = obj?.gdrive_file_id;
    this.gdrive_path = obj?.gdrive_path;
    this.folder_path = obj?.folder_path;
    this.start_date = obj?.start_date;
    this.end_date = obj?.end_date;
    this.updated_end_date = obj?.updated_end_date;
    this.remaining_days = obj?.remaining_days;
    this.contract_type = obj?.contract_type;
    this.sow_number = obj?.sow_number;
    this.order_form_number = obj?.order_form_number;
    this.children = obj?.children || []; // Keep children array intact
    this.expanded = obj?.expanded || false;
  }
}

export class ContractExpiryTable {
  count: number;
  results: ExpiringContractData[];
  previous: any;
  next: any;

  constructor(obj: any) {
    this.count = obj?.count;
    this.results = obj?.results?.map(
      (res: any) => new ExpiringContractData(res)
    );
    this.previous = obj?.previous;
    this.next = obj?.next;
  }
}

// V2 Table Model for Hierarchical Data (Agentic Dashboard)
export class ContractExpiryTableV2 {
  count: number;
  total_count: number;
  results: HierarchicalContractData[];
  previous: any;
  next: any;
  filters: any;
  page: number;
  pageSize: number;

  constructor(obj: any) {
    this.count = obj?.count;
    this.total_count = obj?.total_count;
    // Preserve hierarchical structure - no transformation
    this.results = obj?.results?.map(
      (res: any) => new HierarchicalContractData(res)
    );
    this.previous = obj?.previous;
    this.next = obj?.next;
    this.filters = obj?.filters;
    this.page = obj?.page;
    this.pageSize = obj?.pageSize;
  }
}

export class ContractSyncRow {
  id: string;
  vertical_name: string;
  vertical_id: string;
  src_drive_link: string;
  dest_drive_link: string;
  year: string;
  synced_on: string;
  synced_by: UserDetails;
  status: string;
  total_files: number;
  contract_moved: {
    moved: number;
    failed: number;
    not_moved: number;
  };
  constructor(obj: any) {
    this.id = obj?.id;
    this.vertical_name = obj?.vertical_name;
    this.vertical_id = obj?.vertical_id;
    this.src_drive_link = obj?.source_drive_link;
    this.dest_drive_link = obj?.destination_drive_link;
    this.year = obj?.year;
    this.synced_on = getLocalDateTimeFromTimestamp({
      timestamp: obj?.executed_at,
      dateformat: "MM/DD/YYYY",
    }).date;
    this.synced_by = new UserDetails(obj?.executed_by);
    this.status = obj?.status;
    this.total_files = obj?.total_files;
    this.contract_moved = obj?.contract_moved;
  }
}

export class ContractSyncTable {
  count: number;
  results: ContractSyncRow[];
  previous: any;
  next: any;

  constructor(obj: any) {
    this.count = obj?.count;
    this.results = obj?.results?.map((res: any) => new ContractSyncRow(res));
    this.previous = obj?.previous;
    this.next = obj?.next;
  }
}

export class ContractSyncDetailsRow {
  id: string;
  contract_name: string;
  drive_path: string;
  contract_id: string;
  contract_type: string;
  expiry_date: string;
  status: string;

  constructor(obj: any) {
    this.id = obj?.id;
    this.contract_name = obj?.contract_name;
    this.drive_path = obj?.drive_path;
    this.contract_id = obj?.contract_id;
    this.contract_type = obj?.contract_type;
    this.expiry_date = getLocalDateTimeFromTimestamp({
      timestamp: obj?.expiry_date,
      dateformat: "MM/DD/YYYY",
    }).date;
    this.status = obj?.status;
  }
}

export class ContractSyncDetailsTable {
  count: number;
  results: ContractSyncDetailsRow[];
  previous: any;
  next: any;
  year: string;
  synced_on: string;
  synced_by: UserDetails;
  destination_drive_link: string;
  total_contracts_synced: number;
  contracts_moved: number;
  contracts_failed: number;
  contracts_not_moved: number;
  vertical: string;

  constructor(obj: any) {
    const { pagination, files } = obj?.sync_job_files;
    this.count = pagination?.count;
    this.results = files?.map((res: any) => new ContractSyncDetailsRow(res));
    this.previous = pagination?.previous;
    this.next = pagination?.next;
    this.year = obj?.year;
    this.synced_on = getLocalDateTimeFromTimestamp({
      timestamp: obj?.synced_on,
      dateformat: "MM/DD/YYYY",
    }).date;
    this.synced_by = new UserDetails(obj?.synced_by);
    this.destination_drive_link = obj?.destination_drive_link;
    this.total_contracts_synced = obj?.total_contracts_synced;
    this.contracts_moved = obj?.contracts_moved;
    this.contracts_failed = obj?.contracts_failed;
    this.contracts_not_moved = obj?.contracts_not_moved;
    this.vertical = obj?.vertical_name;
  }
}

export class TtcChatHistoryRow {
  id: string;
  title: string;
  user_id: string;
  created_at: { date: string; time: string };
  updated_at: { date: string; time: string };
  is_deleted: boolean;

  constructor(obj: any) {
    this.id = obj?.id;
    this.title = obj?.title;
    this.user_id = obj?.user_id;
    this.created_at = getLocalDateTimeFromTimestamp({
      timestamp: obj?.created_at,
      dateformat: "MM/DD/YYYY",
    });
    this.updated_at = getLocalDateTimeFromTimestamp({
      timestamp: obj?.updated_at,
      dateformat: "MM/DD/YYYY",
    });
    this.is_deleted = obj?.is_deleted;
  }
}

export class TTCChatHistoryTable {
  count: number;
  results: TtcChatHistoryRow[];
  previous: any;
  next: any;

  constructor(obj: any) {
    this.count = obj?.count;
    this.results = obj?.results || [];
    this.previous = obj?.previous;
    this.next = obj?.next;
  }
}

export class AdkReferenceFile {
  id: string;
  name: string;
  display_name: string;
  description: string;
  source_uri: string;
  create_time: string;
  update_time: string;
  constructor(obj: any) {
    this.id = obj?.id;
    this.name = obj?.name;
    this.display_name = obj?.display_name;
    this.description = obj?.description;
    this.source_uri = obj?.source_uri;
    this.create_time = obj?.create_time;
    this.update_time = obj?.update_time;
  }
}

export class ADKTtcChatHistoryRow {
  id: string;
  title: string;
  user_id: string;
  created_at: { date: string; time: string };
  updated_at: { date: string; time: string };
  is_deleted: boolean;

  constructor(obj: any) {
    this.id = obj?.id;
    this.title = obj?.appName + " " + obj?.id;
    this.user_id = obj?.userId;
    this.created_at = getLocalDateTimeFromTimestamp({
      timestamp: obj?.created_at,
      dateformat: "MM/DD/YYYY",
    });
    this.updated_at = getLocalDateTimeFromTimestamp({
      timestamp: obj?.lastUpdateTime,
      dateformat: "MM/DD/YYYY",
    });
    this.is_deleted = obj?.is_deleted;
  }
}

export class ArchivalJobRow {
  job_id: string;
  status: string;
  triggered_by: string;
  source_folder_id: string;
  destination_folder_id: string;
  total_contracts: number;
  processed: number;
  moved: number;
  failed: number;
  skipped: number;
  error_message: string | null;
  started_at: string;
  updated_at: string;
  completed_at: string;
  success_rate: number;

  constructor(obj: any) {
    this.job_id = obj?.job_id;
    this.status = obj?.status;
    this.triggered_by = obj?.triggered_by;
    this.source_folder_id = obj?.source_folder_id;
    this.destination_folder_id = obj?.destination_folder_id;
    this.total_contracts = obj?.total_contracts;
    this.processed = obj?.processed;
    this.moved = obj?.moved;
    this.failed = obj?.failed;
    this.skipped = obj?.skipped;
    this.error_message = obj?.error_message;
    this.started_at = obj?.started_at;
    this.updated_at = obj?.updated_at;
    this.completed_at = obj?.completed_at;
    this.success_rate = obj?.success_rate;
  }
}

export class VerticalDetailsTable {
  count: number;
  results: ArchivalJobRow[];
  previous: any;
  next: any;

  constructor(obj: any) {
    this.count = obj?.count || 0;
    this.results = obj?.results?.map((res: any) => new ArchivalJobRow(res)) || [];
    this.previous = obj?.previous;
    this.next = obj?.next;
  }
}

export class JobFileRow {
  archival_id: string;
  contract_id: string;
  gdrive_file_id: string;
  file_name: string;
  source_folder_path: string;
  destination_folder_path: string;
  vendor_name: string;
  client_name: string;
  contract_type: string;
  archival_status: string;
  archival_reason: string | null;
  archived_at: string;

  constructor(obj: any) {
    this.archival_id = obj?.archival_id;
    this.contract_id = obj?.contract_id;
    this.gdrive_file_id = obj?.gdrive_file_id;
    this.file_name = obj?.file_name;
    this.source_folder_path = obj?.source_folder_path;
    this.destination_folder_path = obj?.destination_folder_path;
    this.vendor_name = obj?.vendor_name;
    this.client_name = obj?.client_name;
    this.contract_type = obj?.contract_type;
    this.archival_status = obj?.archival_status;
    this.archival_reason = obj?.archival_reason;
    this.archived_at = obj?.archived_at;
  }
}

export class JobDetailsTable {
  count: number;
  results: JobFileRow[];
  previous: any;
  next: any;

  constructor(obj: any) {
    this.count = obj?.count || 0;
    this.results = obj?.results?.map((res: any) => new JobFileRow(res)) || [];
    this.previous = obj?.previous;
    this.next = obj?.next;
  }
}

export class ContractExecutionRow {
  supplier_entity: string;
  google_entity: string;
  simba_id: string;
  simba_id_url: string | null;
  agreement_type: string;
  effective_date: string;
  end_date: string;
  days_to_expire: number | null;
  title: string;
  contract_hierarchy: string;
  docusign_id: string;
  docusign_id_url: string | null;
  status: string;
  bh_link: string;
  bh_link_url: string | null;
  notes_comments: string;
  notes_comments_url: string | null;
  rag_file_id: string;
  vertical: string;
  file_name: string;

  private static parseEmbeddedLink(value: any) {
    if (typeof value !== "string") {
      return { text: "", url: null as string | null };
    }

    const trimmed = value.trim();
    const match = trimmed.match(/^(.*?)\s*\[(https?:\/\/[^\]]+)\]\s*$/i);

    if (!match) {
      return { text: trimmed, url: null as string | null };
    }

    const text = (match[1] || "").trim();
    const url = (match[2] || "").trim();

    return {
      text: text || trimmed,
      url: url || null,
    };
  }

  private static getValidHttpUrl(url: any) {
    if (typeof url !== "string") return null;
    const trimmed = url.trim();
    return /^https?:\/\//i.test(trimmed) ? trimmed : null;
  }

  constructor(obj: any) {
    this.supplier_entity = obj?.supplier_entity || "";
    this.google_entity = obj?.google_entity || "";
    
    // Map sow_contract_id -> MSA/GA/SOW Simba ID column
    const simbaRaw = obj?.sow_contract_id;
    if (typeof simbaRaw === 'object' && simbaRaw !== null) {
      const parsedSimba = ContractExecutionRow.parseEmbeddedLink(simbaRaw?.value || "");
      this.simba_id = parsedSimba.text;
      this.simba_id_url =
        ContractExecutionRow.getValidHttpUrl(simbaRaw?.url) ||
        parsedSimba.url ||
        null;
    } else {
      const parsedSimba = ContractExecutionRow.parseEmbeddedLink(simbaRaw || "");
      this.simba_id = parsedSimba.text;
      this.simba_id_url = obj?.sow_contract_id_url ?? parsedSimba.url;
    }
    
    this.agreement_type = obj?.agreement_type || "";
    this.effective_date = obj?.effective_date || "";
    this.end_date = obj?.end_date || "";
    this.days_to_expire = obj?.days_to_expire ?? null;
    this.title = obj?.title || "";
    this.contract_hierarchy = obj?.contract_hierarchy || "";
    
    // Handle nested object structure for docusign_id (docusign_id.value and docusign_id.url)
    if (typeof obj?.docusign_id === 'object' && obj?.docusign_id !== null) {
      const parsedDocusign = ContractExecutionRow.parseEmbeddedLink(
        obj?.docusign_id?.value || ""
      );
      this.docusign_id = parsedDocusign.text;
      this.docusign_id_url =
        ContractExecutionRow.getValidHttpUrl(obj?.docusign_id?.url) ||
        parsedDocusign.url ||
        null;
    } else {
      const parsedDocusign = ContractExecutionRow.parseEmbeddedLink(obj?.docusign_id || "");
      this.docusign_id = parsedDocusign.text;
      this.docusign_id_url = obj?.docusign_id_url ?? parsedDocusign.url;
    }
    
    this.status = obj?.status || "";
    
    // Handle nested object structure for bh_link (bh_link.value and bh_link.url)
    if (typeof obj?.bh_link === 'object' && obj?.bh_link !== null) {
      const parsedBhLink = ContractExecutionRow.parseEmbeddedLink(obj?.bh_link?.value || "");
      this.bh_link = parsedBhLink.text;
      this.bh_link_url =
        ContractExecutionRow.getValidHttpUrl(obj?.bh_link?.url) ||
        parsedBhLink.url ||
        null;
    } else {
      const parsedBhLink = ContractExecutionRow.parseEmbeddedLink(obj?.bh_link || "");
      this.bh_link = parsedBhLink.text;
      this.bh_link_url = obj?.bh_link_url ?? parsedBhLink.url;
    }
    
    // Handle notes_comments - supports { value, url } object or embedded link format
    if (typeof obj?.notes_comments === 'object' && obj?.notes_comments !== null) {
      const parsedNotes = ContractExecutionRow.parseEmbeddedLink(obj?.notes_comments?.value || "");
      this.notes_comments = parsedNotes.text;
      this.notes_comments_url =
        ContractExecutionRow.getValidHttpUrl(obj?.notes_comments?.url) ||
        parsedNotes.url ||
        null;
    } else {
      const parsedNotes = ContractExecutionRow.parseEmbeddedLink(obj?.notes_comments || "");
      this.notes_comments = parsedNotes.text;
      this.notes_comments_url = obj?.notes_comments_url ?? parsedNotes.url;
    }
    this.rag_file_id = obj?.rag_file_id || "";
    this.vertical = obj?.vertical || "";
    this.file_name = obj?.file_name || "";
  }
}

export class ContractExecutionTable {
  count: number;
  results: ContractExecutionRow[];
  previous: any;
  next: any;
  supplierFilterOptions: any;

  constructor(obj: any) {
    this.count = obj?.total_count ?? obj?.count ?? 0;
    this.results = obj?.contracts?.map((contract: any) => new ContractExecutionRow(contract)) || [];
    this.previous = null;
    this.next = null;
    this.supplierFilterOptions = obj?.filters || obj?.supplier_filter_options || [];
  }
}
